import React from 'react';
import styles from '../../utils/styles/components/Navigation/style.module.css';

export const Navigation = ({ items = [] }) => {
  return (
    <nav className={styles.nav}>
      <div className={styles.inner}>
        <a className={styles.brand} href="#/">
          Sylvie Willms
        </a>
        <div className={styles.links}>
          {items.map((item) => (
            <button
              key={item.id}
              className={styles.link}
              onClick={item.onClick}
              type="button"
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};
